import { classic } from './classic'
import { gti } from './gti'

export const variants = { classic, gti }
export const defaultLayout = 'classic'

export const buildRoutes = (variant, options) => {
  return (variants[variant] || variants[defaultLayout])(options)
}
